import { render, staticRenderFns } from "./ModalContactInsurance.vue?vue&type=template&id=2899fd24&"
import script from "./ModalContactInsurance.vue?vue&type=script&lang=js&"
export * from "./ModalContactInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports